import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

let cachedPromise = null;
let cachedData = null;

export function loadSettings() {
  if (cachedData) return Promise.resolve(cachedData);
  if (cachedPromise) return cachedPromise;
  cachedPromise = axios.get(`${API}/api/settings`).then((r) => {
    cachedData = r.data; return cachedData;
  }).catch((e) => { cachedPromise = null; throw e; });
  return cachedPromise;
}

export function invalidateSettings() {
  cachedData = null; cachedPromise = null;
}

export function useSettings() {
  const [data, setData] = useState(cachedData);
  useEffect(() => {
    if (cachedData) { setData(cachedData); return; }
    loadSettings().then(setData).catch(() => {});
  }, []);
  return data;
}
